export const MESSAGE_PER_PAGE_MAX = 10;

export const MESSAGE_IMAGE_SHOW_EXTENSION: string[] = [
  "jpg",
  "jpeg",
  "JPG",
  "JPEG",
  "png",
];
